/*
 * File: DebugHelpers.ts
 * Project: mp-mobile-app
 *
 * Created by Cole on 02/17/2022
 *
 * Copyright (c) 2022 MacPractice, Inc. All rights reserved.
 *
 * Description: Contains utilities to help with inspecting state and debugging issues from the developer console
 */

import { AppClass } from "./App";
import { getSnapshot, Instance } from "mobx-state-tree";
import { PreferenceBase } from "services/preferences/models/PreferenceBase";
import PreferencesStore from "services/preferences/Store";

declare global {
  interface Window {
    _app?: AppClass;
    mp: typeof debugHelpers;
  }
}

const debugHelpers = {
  preferences(): any {
    const prefs: { [key: string]: any } = {};
    for (const anyPref of Object.values(
      (window._app?.state?.storeManager.getStore(PreferencesStore)
        .preferences as unknown) as Instance<typeof PreferenceBase> & {
        value: any;
      }
    )) {
      const pref = (anyPref as unknown) as Instance<typeof PreferenceBase> & {
        value: any;
      };
      const snapshot = getSnapshot(pref) as any;
      prefs[snapshot.pkey] = snapshot.value;
    }
    return prefs;
  }
};

window.mp = debugHelpers;
